import { render, staticRenderFns } from "./custmEmpty.vue?vue&type=template&id=52d7c8d7&scoped=true&"
import script from "./custmEmpty.vue?vue&type=script&lang=js&"
export * from "./custmEmpty.vue?vue&type=script&lang=js&"
import style0 from "./custmEmpty.vue?vue&type=style&index=0&id=52d7c8d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7c8d7",
  null
  
)

export default component.exports